query scenariosBase($filter: ScenariosInput) {
  base {
    scenarios(filter: $filter) {
      id
      name
      status {
        value
      }
      workspace {
        id
        name
      }
      productiveOrigin {
        id
        label
      }
    }
  }
}
